import { render, staticRenderFns } from "./PdfContent.vue?vue&type=template&id=4c570696&scoped=true&"
import script from "./PdfContent.vue?vue&type=script&lang=js&"
export * from "./PdfContent.vue?vue&type=script&lang=js&"
import style0 from "./PdfContent.vue?vue&type=style&index=0&id=4c570696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c570696",
  null
  
)

export default component.exports